import { create } from "zustand";
import type { Uuid } from "@shared/api";

/**
 * Сервер, на который только что вступили по приглашению, — его экран
 * приветствия ещё не показан. Пометку ставит то место, где вступили (окно
 * «Войти по коду», карточка в ленте), а снимает окно: показало или
 * выяснило, что показывать нечего. В памяти, не на диске: перезапуск
 * посреди вступления — не повод встречать второй раз.
 */
export const useGreeting = create<{ pending: Uuid | null }>(() => ({ pending: null }));

export const greet = (serverId: Uuid) => useGreeting.setState({ pending: serverId });
export const greeted = () => useGreeting.setState({ pending: null });
